import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';

export default class JobFullDetailsDriverMessages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      driver_messages_data: props.driver_messages_data || null,
      isLoadingDriverMessagesInfo: true
    };

    Echo.channel(
      'driver-messages-table-'+this.state.data.id
    ).
    listen(
      'NewDriverMessage',
      (e) => {
        this.getDriverMessages();
      }
    );
  }
  componentDidMount() {
    this.getDriverMessages();
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data,
      driver_messages_data: nextProps.driver_messages_data
    });
  }

  getDriverMessages() {
    let url = '/api/v1/portal/driver-messages/job/'+this.state.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token,
        "Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((driverMessagesJson) => {
        this.setState({
          driver_messages_data: driverMessagesJson['invoice_data'],
          isLoadingDriverMessagesInfo: false,
        })
      });
    });
  }

  render() {
    let DriverMessages = [];
    if (this.state.driver_messages_data &&
      this.state.driver_messages_data.length > 0) {
      let jobId = this.state.data.id;
      this.state.driver_messages_data.forEach(function(i) {
        DriverMessages.push(
          <div key={"job-"+jobId+'-driver-message-'+i.id}>
            driver message here
          </div>
        )
      });
    }
    return (
      <div>
        {DriverMessages}
      </div>
    );
  }
}